import { PHARMACY_COPY } from '../pharmacyCopy';

const copy = PHARMACY_COPY.ALERTS;

export const ALERT_TYPES = ['', 'OUT_OF_STOCK', 'LOW_STOCK', 'EXPIRED', 'EXPIRING'];

export const ALERT_TYPE_LABEL = {
  OUT_OF_STOCK: copy.TYPE_OUT_OF_STOCK,
  LOW_STOCK: copy.TYPE_LOW_STOCK,
  EXPIRED: copy.TYPE_EXPIRED,
  EXPIRING: copy.TYPE_EXPIRING
};

export const ALERT_TYPE_COLORS = {
  OUT_OF_STOCK: '#dc2626',
  LOW_STOCK: '#d97706',
  EXPIRED: '#7c3aed',
  EXPIRING: '#f59e0b'
};

export const ALERT_TYPE_CHART_ORDER = ['OUT_OF_STOCK', 'LOW_STOCK', 'EXPIRED', 'EXPIRING'];

export function alertTypeLabel(type) {
  return ALERT_TYPE_LABEL[type] || type || '—';
}

export function alertSeverityClass(severity) {
  if (severity === 'CRITICAL') return 'cp-status-pill--danger';
  if (severity === 'WARNING') return 'cp-status-pill--warn';
  return 'cp-status-pill--muted';
}

export function alertTypePillClass(type) {
  if (type === 'OUT_OF_STOCK' || type === 'EXPIRED') return 'cp-status-pill--danger';
  if (type === 'LOW_STOCK' || type === 'EXPIRING') return 'cp-status-pill--warn';
  return 'cp-status-pill--muted';
}

export function alertDetailText(alert) {
  if (!alert) return '—';
  if (alert.type === 'LOW_STOCK' || alert.type === 'OUT_OF_STOCK') {
    return `Dispo ${alert.on_hand ?? '—'} / seuil ${alert.min_stock ?? '—'}`;
  }
  return `Lot ${alert.lot_number || '—'} · ${alert.expiry_date || '—'} (${alert.days_left ?? '—'} j)`;
}
